type TenantContact = {
  phoneLabel: string;
  phone: string;
  hours: string;
  /** 受付時間の下に追加で表示する補足行（期間や除外日など） */
  hoursNotes?: string[];
  manualUrl?: string;
  /** メールでの問い合わせ先 */
  email?: string;
  /** 問い合わせ先の公式サイトURL */
  url?: string;
};

const DEFAULT_TENANT_CONTACT: TenantContact = {
  phoneLabel: "お電話でのお問い合わせ",
  phone: "022-200-6923",
  hours: "祝日と年末年始を除く9時から17時30分まで",
  manualUrl:
    "https://drive.google.com/file/d/1SaNSFGNH9NjkIseDJh-9CGSRBedLZO0i/view?usp=sharing",
};

const TENANT_CONTACT: Record<string, TenantContact> = {
  hokkaido: {
    phoneLabel: "道民生活応援ポイント給付事業事務局 取扱店舗コールセンター",
    phone: "0120-651-745",
    hours: "9:00〜17:00",
    hoursNotes: [
      "2026/6/15（月）〜2027/1/29（金）まで",
      "※2026/12/31（木）〜2027/1/3（日）を除く",
    ],
  },
  "kyoto-kyoto": {
    phoneLabel: "京都ポイント（きょうぽ）参加店舗事務局",
    phone: "0570-036-352",
    hours: "平日（月曜〜金曜） 9:00〜19:00",
    hoursNotes: ["土曜・日曜・祝日 10:00〜18:00"],
    email: "kyopo@dejipo.com",
    url: "https://kyopo.city.kyoto.lg.jp",
  },
};

export function getTenantContact(tenantSlug: string): TenantContact {
  const contact = TENANT_CONTACT[tenantSlug];
  if (!contact) {
    return DEFAULT_TENANT_CONTACT;
  }
  return contact;
}

export const HIDE_BANK_ACCOUNT_INFO_COMPANY_IDS = [
  "5ec6b9f3-b182-4fea-befb-870731561e7b", // エスパル仙台
];

export const HIDE_REFUND_BUTTON_COMPANY_IDS = [
  "5ec6b9f3-b182-4fea-befb-870731561e7b", // エスパル仙台
];
